<script setup lang="ts">
const emit = defineEmits<{
  digit: [digit: string]
}>()

// .btn + .btn-number from the old Bootstrap port, as utilities (10px root).
const btnNumber =
  'inline-block font-normal text-center whitespace-nowrap align-middle touch-manipulation ' +
  'cursor-pointer select-none border no-underline hover:no-underline focus:no-underline ' +
  'active:outline-0 relative m-[3px] w-[55px] h-[55px] p-[12px] rounded-full border-[#073b4c] ' +
  'bg-transparent text-[21px] leading-[1.42857143] text-[#073b4c] font-[Lato,sans-serif] ' +
  'hover:text-[#57bbe4] hover:border-[#57bbe4]'
</script>

<template>
  <div class="text-white w-fit overflow-hidden h-auto mx-auto mb-auto mt-[30px]">
    <div>
      <a :class="btnNumber" @click="emit('digit', '1')">1</a>
      <a :class="btnNumber" @click="emit('digit', '2')">2</a>
      <a :class="btnNumber" @click="emit('digit', '3')">3</a>
    </div>
    <div class="mt-[10px]">
      <a :class="btnNumber" @click="emit('digit', '4')">4</a>
      <a :class="btnNumber" @click="emit('digit', '5')">5</a>
      <a :class="btnNumber" @click="emit('digit', '6')">6</a>
    </div>
    <div class="mt-[10px]">
      <a :class="btnNumber" @click="emit('digit', '7')">7</a>
      <a :class="btnNumber" @click="emit('digit', '8')">8</a>
      <a :class="btnNumber" @click="emit('digit', '9')">9</a>
    </div>
    <div class="mt-[10px]">
      <a :class="btnNumber" @click="emit('digit', '*')"
        ><span class="relative top-[3px]">*</span></a
      >
      <a :class="btnNumber" @click="emit('digit', '0')">0</a>
      <a :class="btnNumber" @click="emit('digit', '#')">#</a>
    </div>
  </div>
</template>
